module.exports = __webpack_public_path__ + "img/img-51.c579be9f.png";